import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import TranscriptImportVtt from './TranscriptImportVtt.vue'

declareVconsoleComponent('transcriptImportVtt', TranscriptImportVtt, 'transcript:import_vtt')